(function() {
	'use strict';

	angular.module('fuelBurnDiscrepancy').config(config);

	function config($stateProvider) {
		$stateProvider
				.state(
						'fuelBurnDiscrepancy',
						{
							url : '/fuel-burn-discrepancy',
							views : {
								'fuelBurnDiscrepancyView' : {
									templateUrl : 'fuel-burn-discrepancy/views/fuel-burn-discrepancy.tpl.html',
									controller : 'FuelBurnDiscrepancyCtrl',
									controllerAs : 'fuelBurnDiscrepancy'
								}
							}
						});
	}
}());
